import { createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '../../components';
import { SkuDetail, requireMarketEnabled } from '../../features/market';

const SkuDetailPage = () => {
  const { number } = Route.useParams();
  return (
    <PageContainer>
      <SkuDetail number={Number(number)} />
    </PageContainer>
  );
};

export const Route = createFileRoute('/_auth/market/$number')({
  beforeLoad: requireMarketEnabled,
  component: SkuDetailPage,
});
